import Vue from 'vue'
import Transformer from '@/transformers/transformer'
import moment from 'moment'
import 'moment/locale/es-mx'

class creditNotesTransformer extends Transformer {
  static fetch({ uuid, amount, date, pdf_file: pdf, xml_file: xml }) {
    return {
      uuid,
      amount,
      invoiceDate: moment(date).format('DD/MM/YYYY'),
      pdf,
      xml
    }
  }
}
/**
 * @author Jorge Nuñez Lopez.
**/

export default (casualtyId, config) =>
  Vue.$http.get(`/tax-receipt/purchase-note/files/${casualtyId}/`, config)
    .then(({ data = [] }) => data.length ? creditNotesTransformer.fetchCollection(data) : [])
